import { BookOpen, Mic2, Users, Presentation, GraduationCap, Building2, Handshake } from "lucide-react";

// Marketing formats only. Persisted event categories remain unchanged.
export const CORPORATE_EVENT_FORMATS = [
  { id: "workshops", search: "workshop", icon: BookOpen },
  { id: "palestras", search: "palestra", icon: Mic2 },
  { id: "summits", search: "summit", icon: Users },
  { id: "congressos", search: "congresso", icon: Presentation },
  { id: "treinamentos", search: "treinamento", icon: GraduationCap },
  { id: "convencoes", search: "convenção", icon: Building2 },
  { id: "networking", search: "networking", icon: Handshake },
] as const;
